<template>
    <div :class="paymentsListClass">
        <table>
            <tr v-for="option in field.options" :key="option.id">
                <td>
                    <div style="position:relative;padding-left:1.25rem">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            :name="field.name"
                            :id="option.id"
                            :value="option.value"
                            v-model="checked"
                            v-on:change="fillOutFromCheckbox()"
                        >
                        <FieldLabel :label="option" :fieldId="option.id" :product="option"/>
                    </div>
                </td>
                <td>
                    <Quantity
                        v-if="optionSelected(option.value)"
                        :min="min"
                        :defaultQuantity="defaultQuantity"
                        :disableQuantity="field.product.disableQuantity"
                        v-on:filled-out="fillOutFromQuantity(option.value, $event)"
                    >
                    </Quantity>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
  import FieldLabel from '../FieldLabel';
  import Quantity from './Quantity';

  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
      return {
        checked: [],
        min: 1,
        defaultQuantity: 1,
        filledOutData: {}
      };
    },
    methods: {
        optionSelected(value) {
            return this.checked.includes(value);
        },
        fillOutFromCheckbox() {
            var i;
            for (i in this.filledOutData) {
                if (!this.checked.includes(i)) {
                    delete this.filledOutData[i];
                }
            }
            for (i in this.checked) {
                if (!this.filledOutData[this.checked[i]]) {
                    this.filledOutData[this.checked[i]] = this.defaultQuantity;
                }
            }
            this.$emit('filled-out', this.filledOutData);
        },
        fillOutFromQuantity(value, quantity) {
            this.filledOutData[value] = quantity;
            this.$emit('filled-out', this.filledOutData);
        },
        addDefaultOptions() {
            let me = this;
            let emitEvent = false;

            this.field.options.forEach(function(option) {
                if (option.hasOwnProperty("selected") &&
                    option.selected === true && 
                    !me.checked.includes(option.value)) {
                    me.checked.push(option.value);
                    emitEvent = true;
                }
            });

            if (emitEvent) {
                this.fillOutFromCheckbox();
            }
        }
    },
    computed: {
        paymentsListClass() {
            return {
                'payments-list-field': true,
                'with-quantity': !this.field.product.disableQuantity
            };
        }
    },
    created() {
        // Make sure default options are selected
        this.addDefaultOptions();
    },
    components: {
      FieldLabel,
      Quantity
    },
  };
</script>

<style>
</style>
